import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getStockStatusCostCenterCodes, getStockStatusSummaryReportGrid, getStockStatusSummaryPopup } from '../../api/ReportsAPI/stockStatusReportAPI';

const err = (e, fallback) => e?.Message || e?.message || fallback;

export const fetchStockStatusCCList = createAsyncThunk('stockStatusReport/fetchCCList', async (params, { rejectWithValue }) => {
    try { const res = await getStockStatusCostCenterCodes(params); return res?.Data || []; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch cost centres')); }
});

export const fetchStockStatusReport = createAsyncThunk('stockStatusReport/fetchReport', async (params, { rejectWithValue }) => {
    try { const res = await getStockStatusSummaryReportGrid(params); return res?.Data || null; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch stock status report')); }
});

export const fetchStockStatusPopup = createAsyncThunk('stockStatusReport/fetchPopup', async (params, { rejectWithValue }) => {
    try { const res = await getStockStatusSummaryPopup(params); return res?.Data || []; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch stock status detail')); }
});

const initialState = {
    ccList: [], ccListLoading: false,
    report: null, reportLoading: false, reportError: null,
    popupData: [], popupLoading: false, popupError: null,
};

const stockStatusReportSlice = createSlice({
    name: 'stockStatusReport',
    initialState,
    reducers: {
        clearStockStatusReport: (s) => { s.report = null; s.reportError = null; },
        clearStockStatusPopup: (s) => { s.popupData = []; s.popupError = null; },
        resetStockStatusReport: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStockStatusCCList.pending, (s) => { s.ccListLoading = true; })
            .addCase(fetchStockStatusCCList.fulfilled, (s, a) => { s.ccListLoading = false; s.ccList = a.payload; })
            .addCase(fetchStockStatusCCList.rejected, (s) => { s.ccListLoading = false; });

        builder
            .addCase(fetchStockStatusReport.pending, (s) => { s.reportLoading = true; s.reportError = null; })
            .addCase(fetchStockStatusReport.fulfilled, (s, a) => { s.reportLoading = false; s.report = a.payload; })
            .addCase(fetchStockStatusReport.rejected, (s, a) => { s.reportLoading = false; s.reportError = a.payload; });

        builder
            .addCase(fetchStockStatusPopup.pending, (s) => { s.popupLoading = true; s.popupError = null; })
            .addCase(fetchStockStatusPopup.fulfilled, (s, a) => { s.popupLoading = false; s.popupData = a.payload; })
            .addCase(fetchStockStatusPopup.rejected, (s, a) => { s.popupLoading = false; s.popupError = a.payload; });
    },
});

export const { clearStockStatusReport, clearStockStatusPopup, resetStockStatusReport } = stockStatusReportSlice.actions;

export const selectStockStatusCCList        = (s) => s.stockStatusReport.ccList;
export const selectStockStatusCCListLoading = (s) => s.stockStatusReport.ccListLoading;
export const selectStockStatusReport        = (s) => s.stockStatusReport.report;
export const selectStockStatusReportLoading = (s) => s.stockStatusReport.reportLoading;
export const selectStockStatusReportError   = (s) => s.stockStatusReport.reportError;
export const selectStockStatusPopupData     = (s) => s.stockStatusReport.popupData;
export const selectStockStatusPopupLoading  = (s) => s.stockStatusReport.popupLoading;
export const selectStockStatusPopupError    = (s) => s.stockStatusReport.popupError;

export default stockStatusReportSlice.reducer;
